import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-slate-900">
      <div className="container mx-auto px-6 py-10 sm:py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center mb-6">
              <video src="/assets/logo.gif.mp4" poster="/assets/optimized/gec-logo.webp" className="h-16 w-auto object-contain" width="220" height="166" autoPlay loop muted playsInline aria-label="Global Educational Consultants logo" />
            </div>
            <p className="text-slate-700 mb-6">
              Global Educational Consultants helps students find the right international education pathway and move confidently from course selection to departure.
            </p>
            <div className="flex space-x-4" aria-label="Social media links"><a href="#" aria-label="Facebook" className="text-slate-600 hover:text-blue-700 transition-colors"><i className="ri-facebook-fill text-xl"></i></a><a href="#" aria-label="Instagram" className="text-slate-600 hover:text-blue-700 transition-colors"><i className="ri-instagram-line text-xl"></i></a><a href="#" aria-label="YouTube" className="text-slate-600 hover:text-blue-700 transition-colors"><i className="ri-youtube-fill text-xl"></i></a><a href="#" aria-label="LinkedIn" className="text-slate-600 hover:text-blue-700 transition-colors"><i className="ri-linkedin-fill text-xl"></i></a><a href="https://wa.me/919020500700" aria-label="WhatsApp" className="text-slate-600 hover:text-blue-700 transition-colors"><i className="ri-whatsapp-line text-xl"></i></a></div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-slate-600 hover:text-blue-700 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-slate-600 hover:text-blue-700 transition-colors">About Us</Link></li>
              <li><Link to="/courses" className="text-slate-600 hover:text-blue-700 transition-colors">Courses</Link></li>
              <li><Link to="/colleges" className="text-slate-600 hover:text-blue-700 transition-colors">Colleges & Universities</Link></li>
              <li><Link to="/events" className="text-slate-600 hover:text-blue-700 transition-colors">Events</Link></li>
              <li><Link to="/consultation" className="text-slate-600 hover:text-blue-700 transition-colors">Free Consultation</Link></li>
              <li><Link to="/delegate-meetings" className="text-slate-600 hover:text-blue-700 transition-colors">Delegate Meetings</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li><span className="text-slate-700">University Selection</span></li>
              <li><span className="text-slate-700">Application Assistance</span></li>
              <li><span className="text-slate-700">Visa Guidance</span></li>
              <li><span className="text-slate-700">Scholarship Support</span></li>
              <li><span className="text-slate-700">Test Preparation</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-blue-400 mt-1 mr-3"></i>
                <span className="text-slate-700">
                  Metro Pillar 595, II Floor<br />
                  Penta Towers, Adj. Kaloor Metro Station<br />
                  Cochin, Kerala, INDIA 682017
                </span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-blue-400 mr-3"></i>
                <span className="text-slate-700">+91 9020 500 700</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-blue-400 mr-3"></i>
                <span className="text-slate-700">info@globaledu.in</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
            <p className="text-slate-600 text-sm">              &copy; 2024 GEC Educational Consultancy. All rights reserved.
            </p>
            <Link
              to="/terms"
              className="text-slate-600 hover:text-blue-700 text-sm transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
